import { useEffect, useRef } from 'react';
import { trackPostHogEvent, debounce } from '@/lib/analytics';

const SCROLL_THRESHOLDS = [10, 25, 50, 75, 100];

export const useScrollTracking = () => {
  const trackedThresholds = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handleScroll = debounce(() => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (window.scrollY / scrollHeight) * 100;
      const scrollDepthPixels = window.scrollY;
      const viewportHeight = window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      SCROLL_THRESHOLDS.forEach((threshold) => {
        if (
          scrollPercentage >= threshold &&
          !trackedThresholds.current.has(threshold)
        ) {
          trackedThresholds.current.add(threshold);
          
          // Track with enriched properties
          trackPostHogEvent('scroll_depth_reached', {
            scroll_percentage: `${threshold}%`,
            scroll_depth_pixels: scrollDepthPixels,
            viewport_height: viewportHeight,
            page_height: pageHeight,
          });
        }
      });
    }, 300); // Debounce 300ms

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Reset tracked thresholds when component unmounts or page changes
  useEffect(() => {
    return () => {
      trackedThresholds.current.clear();
    };
  }, []);
};
